import { render, staticRenderFns } from "./insOther.vue?vue&type=template&id=12f643e2&"
import script from "./insOther.vue?vue&type=script&lang=js&"
export * from "./insOther.vue?vue&type=script&lang=js&"
import style0 from "./insOther.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports